export const LetterUploadContent = {
  pageTitle: 'Upload letter of account approval',
  pageDescription: `Because you've indicated that you're an associated person, or that another associated person will have financial interest in or trading authority over your new account, you'll need to submit a letter of account approval from a compliance officer at your employer or the firm you're associated with.`,
  continueButton: `Continue`,
  accordions: [
    {
      title: `Where do I get the letter of approval?`,
      text: `The associated firm provides the letter of approval for you to open a brokerage account. If you don’t already have the letter on hand, you can speak to your human resources or compliance department to provide it.`,
    },
    {
      title: `What should be in the letter of approval?`,
      text: `Most associated firms have a standard template for these letters. In general, it should be on the associated firm’s company letterhead. It should also identify the associated person as:<ul><li>Employed by a FINRA member firm, associated, or affiliated, or</li><li>Subject to NYSE Rule 401, NASD Rule 3050, MSRB G-28, or FINRA Rule 3210, or</li><li>A “registered representative” who will perform account transactions on behalf of associated persons.</li></ul>The letter should be signed by a member of the compliance department or other authorized officer of the company, and be dated within 90 days.`,
    },
  ],
  fileUpload: {
    browse: 'browse files',
    description: 'Total upload size: 3.5MB',
    fileTypes: 'Supporting file type: PDF, JPEG, PNG',
    title: 'Drag and drop file here or',
    uploadFileAriaLabel: 'Drag and drop file here or browse files',
  },
  attachedFile: 'file(s) attached',
  fileSizeLimit: 'of 3.5 MB',

  errorMessages: {
    fileTooLarge: 'The file you want to upload is too large. Please reduce its size and try again.',
    invalidFileType:
      'The file you want to upload is an unacceptable file type. Please upload either an image file or a PDF file instead.',
    fileNotSaved: 'The file you want to upload failed to save. Please try again.',
    missingFile: 'Please upload the required document(s) to continue.',
  },
  vgHasLetter: 'Vanguard already has a letter for employees from my firm',
};
